import { Sun, Moon } from 'lucide-react';

interface VisitTypeStepProps {
  onSelect: (visitType: string) => void;
}

const visitOptions = [
  {
    id: 'day',
    title: 'Day Visit Only',
    description: 'Rent Cabana & Picnic Tables - Go Kayaking & Paddleboarding',
    icon: Sun,
    iconColor: 'text-yellow-500',
  },
  {
    id: 'overnight',
    title: 'Stay Overnight Too',
    description: 'Reserve Safari & Glamping Cabins, Bell Tents & Tent Camping Spots',
    icon: Moon,
    iconColor: 'text-teal',
  },
];

const VisitTypeStep = ({ onSelect }: VisitTypeStepProps) => {
  return (
    <div className="p-8">
      <div className="text-center mb-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-brown mb-2">
          What's Your Plan?
        </h2>
        <p className="text-brown/70">
          How would you like to experience Son's?
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {visitOptions.map((option) => {
          const IconComponent = option.icon;
          return (
            <button
              key={option.id}
              onClick={() => onSelect(option.id)}
              className="flex items-center gap-4 p-5 bg-white rounded-xl border-2 border-brown/10 hover:border-teal hover:bg-teal/5 transition-all text-left group"
            >
              <div className={`w-14 h-14 rounded-full bg-teal/10 group-hover:bg-teal flex items-center justify-center transition-all shrink-0`}>
                <IconComponent className={`w-7 h-7 ${option.iconColor} group-hover:text-cream transition-colors`} />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-lg text-brown group-hover:text-teal transition-colors">
                  {option.title}
                </h3>
                <p className="text-sm text-brown/60 mt-0.5">
                  {option.description}
                </p>
              </div>
              <div className="text-brown/30 group-hover:text-teal text-2xl transition-colors">
                →
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VisitTypeStep;
